import { Link } from 'react-router-dom';
import ArticleLayout from '@/pages/article/components/ArticleLayout';
import Footer from '@/pages/home/components/Footer';

export default function BasetaoCouponDiscount() {
  return (
    <>
      <ArticleLayout title="Basetao Coupon & Discount Codes 2026: Save on Every Order" subtitle="The most up-to-date list of Basetao coupons, discount codes, promotional offers, and proven strategies to reduce your total shopping costs throughout the year." tag="Savings">
        <section className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">How to Save Money on Basetao</h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            <strong className="text-foreground-900">Basetao coupon</strong> codes and discounts are released periodically through the platform's announcements and community channels. Common offers include percentage-based service fee reductions, free QC photo add-ons, and seasonal shipping promotions tied to holidays like Chinese New Year and 11.11.
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            Beyond coupon codes, the most reliable way to save is by combining warehouse consolidation with budget shipping lines. A well-organized <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium underline">Basetao spreadsheet</Link> helps you track multiple orders and time your consolidated shipment for maximum savings.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Current Promotions</h2>
          <div className="space-y-3">
            {[
              { deal: 'New User Bonus', desc: 'First-time users often receive service fee discounts on initial orders.' },
              { deal: 'Loyalty Rewards', desc: 'Regular customers may qualify for reduced service rates on larger hauls.' },
              { deal: 'Seasonal Events', desc: 'Major shopping festivals bring temporary shipping discounts and promotions.' },
            ].map((d) => (
              <div key={d.deal} className="flex gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70">
                <div className="w-5 h-5 flex-shrink-0 mt-0.5 flex items-center justify-center text-accent-500"><i className="ri-coupon-line"></i></div>
                <div><h4 className="text-sm font-semibold text-foreground-900 mb-1">{d.deal}</h4><p className="text-xs text-foreground-600">{d.desc}</p></div>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-8">
          <div className="bg-primary-50/50 border border-primary-200/50 rounded-lg p-6 md:p-8 text-center">
            <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">Discover More Resources</h2>
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">Back to BasetaoSheet Home</Link>
          </div>
        </section>
      </ArticleLayout>
      <Footer />
    </>
  );
}